export default __webpack_public_path__ + "static/6_35-3eeeae1cd353f04499c7d794a3eedba9.png";